import { Reveal, Eyebrow } from "./Reveal";
import { CSE_NEEDS } from "../../data";
import { ArrowUpRight } from "lucide-react";

export const CSENeeds = () => {
  return (
    <section id="besoins-cse" className="relative bg-sand-light py-24 sm:py-32" data-testid="cse-needs-section">
      <div className="max-w-6xl mx-auto px-6 sm:px-8">
        <div className="max-w-3xl">
          <Reveal><Eyebrow>L'enjeu CSE & RH</Eyebrow></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-serif font-semibold tracking-tight text-ocean text-3xl sm:text-4xl lg:text-5xl leading-[1.08]">
              Une action CSE visible,<br className="hidden sm:block" /> fédératrice et utile
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-5 text-base sm:text-lg text-muted2 leading-relaxed">
              Au-delà d'une simple sortie, un investissement stratégique dans le capital santé,
              l'attachement à l'entreprise et la cohésion durable de vos équipes.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
          {CSE_NEEDS.map((item, i) => (
            <Reveal key={item.number} delay={i * 0.07}>
              <article
                className="group relative h-full rounded-3xl bg-white border border-ocean/5 p-7 transition-all duration-500 hover:border-gold/40 hover:shadow-[0_20px_50px_rgba(10,34,40,0.09)] hover:-translate-y-1"
                data-testid={`card-cse-need-${item.number}`}
              >
                <div className="flex items-start justify-between">
                  <span className="font-serif text-5xl font-semibold text-palm-light group-hover:text-gold/30 transition-colors">
                    {item.number}
                  </span>
                  <ArrowUpRight className="w-5 h-5 text-ocean/20 group-hover:text-gold transition-colors" />
                </div>
                <h3 className="mt-4 font-serif text-2xl font-semibold text-ocean leading-tight">{item.title}</h3>
                <p className="mt-3 text-sm text-muted2 leading-relaxed">{item.desc}</p>
                <span className="mt-5 inline-block text-[11px] uppercase tracking-[0.15em] font-semibold text-palm bg-palm-light rounded-full px-3 py-1.5">
                  {item.tag}
                </span>
              </article>
            </Reveal>
          ))}

          <Reveal delay={CSE_NEEDS.length * 0.07}>
            <div className="h-full rounded-3xl bg-ocean text-white p-7 flex flex-col justify-between overflow-hidden relative">
              <div className="absolute -right-8 -bottom-8 w-40 h-40 rounded-full bg-gold/15 blur-2xl" />
              <p className="font-serif text-2xl leading-snug relative">
                « Un événement qui se ressent longtemps après le retour au bureau. »
              </p>
              <button
                onClick={() => document.querySelector("#formulaire-devis")?.scrollIntoView({ behavior: "smooth" })}
                className="mt-6 inline-flex items-center gap-2 rounded-full bg-gold hover:bg-gold-hover text-ocean-dark font-semibold px-5 py-3 text-sm w-max transition-all hover:-translate-y-0.5 relative"
                data-testid="cse-cta-button"
              >
                Construire mon projet CSE
                <ArrowUpRight className="w-4 h-4" />
              </button>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
